export default __webpack_public_path__ + "static/media/attendance-button.9cc757b1.png";